// getInquiryList()で取得する際のデータ件数の最大値
export const INQUIRY_LIST_MAX_COUNT = 3000;
// 問い合わせ一覧のページで表示する１ページの件数
export const DATA_PAR_PAGE = 10;
